module.exports = __webpack_public_path__ + "static/home-6fe28f410255a86a6e0751b50bb25041.jpg";